export default __webpack_public_path__ + "images/process_10.svg?aa7264f45dc092d078e4a1ba027c3a44";